// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imgAlertWrap{width:95%;position:fixed;bottom:0;left:2.5%;z-index:9999}.imgAlertMenuListBase{min-height:50px;line-height:50px;color:red}", ""]);
// Exports
module.exports = exports;
